import {useSelector} from "react-redux";
import GeneralStatsMobile from "./mobile";
import GeneralStatsWeb from "./web";
import {useInView} from "react-intersection-observer";

const CasinoDebitStats = () => {

    const {ref, inView} = useInView({
        triggerOnce: true, // Mount the component only once
        threshold: .4, // Mount when 10% of the component is visible
    });

    const {agent} = useSelector(state => state.globalReducer)

    return (
        <div className="col-12 section--first" ref={ref}>
            {
                inView && (
                    agent?.isMobile ? <GeneralStatsMobile/> : <GeneralStatsWeb/>
                )
            }
        </div>
    )

}
export default CasinoDebitStats
